<template>
  <tg-layout :prefixCls="'member-reward--' + project" :headerHeight="headerHeight">
    <template slot="header">
      <slot name="toolbar" :on-search="handleSearch"></slot>
      <tg-amount-bar v-if="showAmount" :columns="amountColumns" :row="amount"></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="tableColumns"
      :proxy="proxy"
      align="center"
      header-row-class-name="tg-table--has-actionis"
      row-class-name="tg-table--has-actionis"
      :fit="true"
      size="medium"
      showPagination
      @on-loaded="handleLoaded"
    >
      <template v-for="(_, slotName) in $scopedSlots" :slot="slotName" slot-scope="scope">
        <slot :name="slotName" v-bind="{ ...scope }"></slot>
      </template>
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name :row="scope.row" :column="scope.column"></tg-user-full-name>
      </template>
    </tg-table>

    <!-- 沙巴串關詳情 -->
    <third-party-saba-detail-dialog
      ref="sabaParlayMatchs"
    ></third-party-saba-detail-dialog>
    <!-- 沙巴串關結果 -->
    <third-party-saba-result-dialog
      ref="sabaParlayResult"
    ></third-party-saba-result-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgUserFullName from "@/components/slot/TgUserFullName";
import ThirdPartySabaDetailDialog from "@/components/dialog/ThirdPartySabaDetailDialog";
import ThirdPartySabaResultDialog from "@/components/dialog/ThirdPartySabaResultDialog";
import apis from "@/apis";

const api = apis.tg_business.member.reward;

export default {
  components: {
    TgLayout,
    TgAmountBar,
    TgUserFullName,
    ThirdPartySabaDetailDialog,
    ThirdPartySabaResultDialog
  },
  data() {
    return {
      amount: {},
      tableColumns: [],
      amountColumns: [],
    };
  },
  props: {
    showAmount: Boolean,
    // 請求資訊
    request: Object,
    project: {
      type: String,
      required: true,
      validator(value) {
        return ["detail", "games"].indexOf(value) > -1;
      },
    },
    params: Object,
  },
  computed: {
    columnsRequest() {
      return {
        project: this.project,
        type: this.reward.type,
        status: this.reward.status,
      };
    },
    reward() {
      return this.params ? this.params.reward : {};
    },
    startDate() {
      return this.params ? this.params.startDate : "";
    },
    endDate() {
      return this.params ? this.params.endDate : "";
    },
    username() {
      return this.params ? this.params.username : "";
    },
    upper_agent() {
      return this.params ? this.params.upper_agent : [];
    },
    source_type() {
      return this.params ? this.params.source_type : "";
    },
    
    searchData() {
      return {
        type: this.reward.type,
        status: this.reward.status,
        username: this.username,
        startDate: this.startDate,
        endDate: this.endDate,
        ...this.request,
        upper_agent: this.upper_agent,
        third_party: this.third_party,
        source_type: this.source_type,
      };
    },
    proxy() {
      let proxy = this.project === "detail" ? api.getDetail : api.getGames;
      return (params) => proxy({ ...this.searchData, ...params });
    },

    headerHeight() {
      return this.showAmount ? 140 : 80;
    },
  },
  created() {
    this.$store.commit("breadcrumb/clear");

    if (!this.reward || !this.reward.type) {
      this.$router.push({ name: "tg_business.member.reward" });
      return;
    }

    this.third_party = this.params.third_party ? this.params.third_party : this.third_party;

    api.getColumns(this.columnsRequest).then((response) => {
      if (this.project === "detail") {
        this.tableColumns = response.data.tableColumns;
        this.amountColumns = response.data.amountColumns;
      } else {
        this.tableColumns = response.data;
      }
      this.$refs.table.init(this.searchData);
    });
  },
  methods: {
    handleLoaded(response) {
      if(response.retcode == 0){
        this.amount = response.amount_data;
      }
    },
    handleSearch(request) {
      this.$refs.table.search({
        ...this.searchData,
        ...request,
      });
    },
  },
  watch: {
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
